import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { Panel } from '../components/primitives/Panel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Home; each part uses its own slice of it */
import styles from './ArtistHome.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** A loading KPI tile in the shape of a real one (design b3). */
const HomeKpiSkeletonComponent: React.FC = () => (
  <Panel className={styles.kpi} aria-hidden>
    <div className={clsx(styles.skLine, 'w-50')} />
    <div className={clsx(styles.skLine, styles.skValue, 'w-75')} />
    <div className={clsx(styles.skLine, 'w-25')} />
  </Panel>
);

export const HomeKpiSkeleton = TypedMemo(HomeKpiSkeletonComponent);
